const copyAdv = {
  holder: document.querySelectorAll(".jsMenuAdvert") as NodeListOf<HTMLElement>,
  advert: document.getElementById("menuAdvert") as HTMLElement | undefined,
  mainAdverts: document.querySelectorAll(
    ".jsAvdertOriginal"
  ) as NodeListOf<HTMLElement>,
  init() {
    this.setAdvert();
    // this.multipleCopy();
  },
  setAdvert() {
    const html = this.advert?.outerHTML;
    if (html) {
      this.holder.forEach((item) => {
        item.innerHTML = html;
      });
    }
  },
  multipleCopy() {
  
    this.mainAdverts.forEach((item) => {
      const id = item.dataset.id as string;
      const div = document.querySelector(`.js${id}`) as HTMLElement | undefined;
      console.log(id, div);
      if (div) {
        div.innerHTML = item.outerHTML;
      }
    });
  },
};

export default copyAdv;
